import React, { LegacyRef, useEffect, useRef } from 'react'
import TourNavigator from './TourNavigator_/TourNavigator'
import TourHelper from './TourHelper'
import TourHelperTwo from './TourHelperTwo'

export default function Test() {

  return (
    <div id='main-container' style={{display: 'flex', background: 'gray', flexDirection: 'column'}}>
        <section id='container' style={{flex: 1, background: 'skyblue', padding: 30, paddingTop: 100}}>
            <span id='test' style={{background: 'green', width: 100, margin: 10}}>Test</span>
            <div>
                <div className='x' style={{marginTop: 1000000, background: 'red'}}></div>
            </div>
            <div style={{height: 400, border: '1px solid black', background: 'yellow', margin: 30, marginTop: 2000}} id='box-1'></div>
        </section>
        <TourNavigator
            helper={TourHelperTwo}
            overlayFill='black'
            steps={[
                {
                    selector: '#test',
                    data: {title: 'Feedback', description: 'Feedback description'},
                },
                {
                    selector: '.x',
                    data: {title: 'Box 1', description: 'Box description'},
                },
                {
                    selector: '#box-1',
                    data: {title: 'Box 2', description: 'Box description'},
                    intersectionOption: {
                        threshold: .5
                    }
                }
            ]}
            // scrollingElement={'#main-container'}
            scrollBehavior='smooth'
            startAt={1}
            overlayOpacity={.9}
        />
    </div>
  )
}
